var map = {
	"./404.svg": 3983,
	"./bug.svg": 2337,
	"./chart.svg": 6707,
	"./clipboard.svg": 5013,
	"./component.svg": 8662,
	"./dashboard.svg": 9088,
	"./documentation.svg": 4473,
	"./drag.svg": 3975,
	"./edit.svg": 7713,
	"./education.svg": 3653,
	"./email.svg": 3751,
	"./example.svg": 613,
	"./excel.svg": 134,
	"./exit-fullscreen.svg": 5441,
	"./eye-open.svg": 9529,
	"./eye.svg": 6240,
	"./form.svg": 4527,
	"./fullscreen.svg": 3090,
	"./guide.svg": 471,
	"./icon.svg": 5242,
	"./international.svg": 9559,
	"./language.svg": 9419,
	"./link.svg": 2273,
	"./list.svg": 8645,
	"./lock.svg": 3368,
	"./message.svg": 1498,
	"./money.svg": 7039,
	"./nested.svg": 8236,
	"./password.svg": 3650,
	"./pdf.svg": 3365,
	"./people.svg": 7908,
	"./peoples.svg": 6895,
	"./qq.svg": 1195,
	"./search.svg": 2701,
	"./shopping.svg": 805,
	"./size.svg": 8418,
	"./skill.svg": 9092,
	"./star.svg": 7841,
	"./tab.svg": 3202,
	"./table.svg": 987,
	"./theme.svg": 8832,
	"./tree-table.svg": 794,
	"./tree.svg": 3585,
	"./user.svg": 3900,
	"./wechat.svg": 7331,
	"./zip.svg": 4002,
	"./zmzq.svg": 6013,
	"./zmzq1.svg": 3814
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2922;